import cn from 'classnames'
import React, { ReactElement, ReactNode } from 'react'

import style from './SettingsTile.style'

type SettingsTileProps = {
  /** Already-translated uppercase kicker rendered as the tile heading. */
  title: string
  children: ReactNode
  className?: string
  /**
   * DOM id, so a tile can be the target of a `#fragment` deep link from another
   * surface. See `settingsAnchors.ts` for the ids that are linked to — an id set
   * here is a contract with the linking side, not a local detail.
   */
  id?: string
}

/**
 * Light bordered container used by every tile in the redesigned physical card
 * Account Settings bento (EX-40354). Renders a section kicker heading + content.
 * A plain surface — 1px border + small radius, no heavy shadow.
 */
export default function SettingsTile(props: SettingsTileProps): ReactElement {
  const { title, children, className = '', id } = props

  return (
    <section id={id} className={cn('SettingsTile', className)} css={style}>
      <h3 className="SettingsTile-kicker">{title}</h3>
      {children}
    </section>
  )
}
